import { useState, useEffect } from 'react'
import { get } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import FormLoader from '../../../../components/loader/FormLoader'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../components/pagination/Pagination'
import PageLoader from '../../../../components/loader/PageLoader'
import FullLoader from '../../../../components/loader/FullLoader'

function Businesses() {
  const baseURL = (import.meta as any).env.VITE_BASE_URL
  const { notify, profile } = useGlobalContext()
  const navigate = useNavigate()
  const [businessesList, setBusinessesList] = useState<any>({ data: [] })
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [KPI, setKPI] = useState<any>({})
  const [kpiLoading, setKpiLoading] = useState(true)

  // Toggle between Businesses and Analytics
  const [activeView, setActiveView] = useState<'businesses' | 'analytics'>('businesses')

  // Analytics state
  const [analyticsData, setAnalyticsData] = useState<any>({ topBusinesses: [] })
  const [analyticsLoading, setAnalyticsLoading] = useState(false)
  const [analyticsParams, setAnalyticsParams] = useState({
    limit: 20,
    from: '',
    to: ''
  })

  function fetchKPI() {
    setKpiLoading(true)
    get('admin/business/kpi')
      .then((result: any) => {
        if (result.status === 200) {
          setKPI(result.data)
        } else {
          notify('error', result.message)
        }
        setKpiLoading(false)
      })
      .catch(() => {
        setKpiLoading(false)
      })
  }

  useEffect(() => {
    fetchKPI()
  }, [])

  function fetchBusinesses(page: number, pageSize: number) {
    setLoading(true)
    let url = ''
    if (search) {
      url = `admin/businesses?search=${search}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/businesses?page=${page}&limit=${pageSize}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setBusinessesList(result.data)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchBusinesses(1, 10)
  }, [])

  // Fetch Analytics Data
  function fetchAnalytics() {
    if (!analyticsParams.from || !analyticsParams.to) {
      notify('error', 'Please select both from and to dates')
      return
    }
    setAnalyticsLoading(true)
    const url = `admin/top-businesses?limit=${analyticsParams.limit}&from=${analyticsParams.from}&to=${analyticsParams.to}`
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setAnalyticsData(result.data)
        } else {
          notify('error', result.message)
        }
        setAnalyticsLoading(false)
      })
      .catch(() => {
        setAnalyticsLoading(false)
      })
  }

  //<----------- Download Excel and CSV --------------->
  const [downloading, setDownloading] = useState(false)

  // Analytics Export
  const handleAnalyticsExport = async () => {
    if (!analyticsParams.from || !analyticsParams.to) {
      notify('error', 'Please select both from and to dates')
      return
    }
    const token = sessionStorage.getItem('token')
    let apiUrl = `${baseURL}/admin/top-businesses/export?limit=${analyticsParams.limit}&from=${analyticsParams.from}&to=${analyticsParams.to}`

    try {
      setDownloading(true)
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error('Failed to download file')
      }

      const blob = await response.blob()
      const fileName = `Top_Businesses_Analytics`

      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
      setDownloading(false)
    } catch (error) {
      console.error('Error downloading the file:', error)
      setDownloading(false)
    }
  }

  // const [downloading, setDownloading] = useState(false)

  // const handleDownload = async (format: string) => {
  //   const token = sessionStorage.getItem('token')
  //   let apiUrl = `${baseURL}/admin/businesses/export?format=${format}`

  //   try {
  //     // Make an API request to fetch the Excel file
  //     setDownloading(true)
  //     const response = await fetch(apiUrl, {
  //       method: 'GET',
  //       headers: {
  //         // Add any necessary headers, like authorization if required
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })

  //     if (!response.ok) {
  //       setDownloading(false)
  //       throw new Error('Failed to download file')
  //     }

  //     // Convert the response to a Blob
  //     const blob = await response.blob()

  //     // Extract the filename from the "Content-Disposition" header
  //     const fileName = `Customers`

  //     // Create a download link for the Blob
  //     const url = window.URL.createObjectURL(blob)
  //     const a = document.createElement('a')
  //     a.href = url
  //     a.download = fileName // Use the filename from the backend
  //     document.body.appendChild(a) // Append to the DOM
  //     a.click() // Trigger the download
  //     a.remove() // Clean up
  //     window.URL.revokeObjectURL(url) // Release memory
  //     setDownloading(false)
  //   } catch (error) {
  //     console.error('Error downloading the file:', error)
  //   }
  // }
  const selectCustomer = (id: string) => {
    navigate(`/admin/business/${id}`)
  }

  //

  return (
    <div className='home'>
      {downloading && <FullLoader />}
      {kpiLoading ? (
        <PageLoader position='center' />
      ) : (
        <div className='home-head'>
          <div className='biz flex justify-between flex-wrap'>
            <div className='card'>
              <p>Total Outstanding</p>
              <h2>₦{KPI.totalOutstanding.toLocaleString()}</h2>
            </div>
            <div className='card'>
              <p>Total Balance</p>
              <h2>₦{KPI.totalBalance.toLocaleString()}</h2>
            </div>
            <div className='card'>
              <p>Business Count</p>
              <h2>{KPI.businessCount.toLocaleString()}</h2>
            </div>
            <div
              className='card'
              onClick={() => navigate('/admin/api-bookings')}
            >
              <p>Overall Booking Count</p>
              <h2>{KPI.bookingCount.toLocaleString()}</h2>
            </div>
            <div
              className='card'
              onClick={() => navigate('/admin/api-bookings')}
            >
              <p>Overall Booking Value</p>
              <h2>
                ₦{parseFloat(KPI.totalCharge.toFixed(2)).toLocaleString()}{' '}
              </h2>
            </div>
            <div
              className='card'
              onClick={() => navigate('/admin/api-bookings')}
            >
              <p>Monthly Valid Booking Count</p>
              <h2>
                {parseFloat(
                  KPI.monthlyData.validBookingCount.toFixed(2)
                ).toLocaleString()}{' '}
              </h2>
            </div>
            <div
              className='card'
              onClick={() => navigate('/admin/api-bookings')}
            >
              <p>Monthly Booking Value</p>
              <h2>
                ₦
                {parseFloat(
                  KPI.monthlyData.totalBookingValue.toFixed(2)
                ).toLocaleString()}{' '}
              </h2>
            </div>
          </div>
        </div>
      )}

      {profile?.role !== 'agent' && (
        <div className='home_tag flex justify-between' style={{ marginTop: '20px', marginBottom: '10px' }}>
          <div className='flex' style={{ gap: '10px' }}>
            <button
              onClick={() => setActiveView('businesses')}
              style={{
                backgroundColor: activeView === 'businesses' ? '#4CAF50' : '#f0f0f0',
                color: activeView === 'businesses' ? 'white' : 'black',
              }}
            >
              Businesses
            </button>
            <button
              onClick={() => setActiveView('analytics')}
              style={{
                backgroundColor: activeView === 'analytics' ? '#4CAF50' : '#f0f0f0',
                color: activeView === 'analytics' ? 'white' : 'black',
              }}
            >
              Analytics
            </button>
          </div>
        </div>
      )}

      <div className='home_tables'>
        <div className='left'>
          {activeView === 'businesses' ? (
            <>
              {loading ? (
                <FormLoader position='center' />
              ) : (
                <>
                  <div className='flex justify-between items-center search-btns flex-wrap'>
                    <div className='search flex flex-wrap'>
                  <input
                    type='search'
                    name=''
                    id=''
                    value={search}
                    placeholder='search by name or tracking Id'
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />{' '}
                  <button
                    onClick={() => {
                      fetchBusinesses(1, 10)
                    }}
                  >
                    Search
                  </button>
                </div>
                {/* <div className='buttons flex dif'>
                  <button onClick={() => handleDownload('csv')}>
                    Export CSV
                  </button>
                  <button onClick={() => handleDownload('excel')}>
                    Export EXCEL
                  </button>
                </div> */}
              </div>
              {businessesList.businesses.length > 0 ? (
                <>
                  <div className='mobile-table'>
                    {businessesList.businesses.map((data: any, i: number) => (
                      <div
                        className='card'
                        onClick={() => navigate(`/admin/business/${data._id}`)}
                        key={data._id}
                      >
                        <div className=' flex justify-between row'>
                          <div className='count flex items-center justify-center'>
                            {i + 1}
                          </div>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Org Name</h4>
                          <p>{data.org_name}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Role</h4>
                          <p>{data.role_level}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Outstanding</h4>
                          <p>₦{data.outstanding.toLocaleString()}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Email</h4>
                          <p>{data.email}</p>
                        </div>
                        <div className='row flex justify-between'>
                          <h4>Status</h4>
                          <p
                            style={{
                              color:
                                data.active === false ? '#dc2626' : '#16a34a',
                            }}
                          >
                            {data.active === false ? 'Deactivated' : 'Active'}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <table className='desktop-table'>
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Org Name</th>
                        <th>Outstanding</th>
                        <th>Role</th>
                        <th>Email</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {businessesList.businesses.map((data: any, i: number) => (
                        <tr key={data._id}>
                          <td>{i + 1}</td>
                          <td onClick={() => selectCustomer(data._id)}>
                            {data.org_name}
                          </td>
                          <td
                            onClick={() => selectCustomer(data._id)}
                            className='count'
                          >
                            ₦{data.outstanding.toLocaleString()}
                          </td>
                          <td className='count'>{data.role_level}</td>
                          <td className='count'>{data.email}</td>
                          <td
                            className='count'
                            style={{
                              color:
                                data.active === false ? '#dc2626' : '#16a34a',
                            }}
                          >
                            {data.active === false ? 'Deactivated' : 'Active'}
                          </td>
                          <td className='icons dif'>
                            <span
                              className='PU'
                              onClick={() => selectCustomer(data._id)}
                            >
                              view
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    className='pagination-bar'
                    currentPage={businessesList.pagination.page}
                    totalCount={businessesList.pagination.totalPages}
                    pageSize={businessesList.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      fetchBusinesses(page, pageSize)
                    }}
                  />
                </>
              ) : (
                <div className='empty flex justify-center'>
                  <div className='empty-cover'>
                    <Icon icon='majesticons:book-line' />
                    <h1>No Bookings To Show</h1>
                  </div>
                </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {analyticsLoading ? (
                <FormLoader position='center' />
              ) : (
                <>
                  <div
                    className='flex justify-between items-center search-btns flex-wrap'
                    style={{ marginBottom: '20px' }}
                  >
                    <div
                      className='search flex flex-wrap'
                      style={{ gap: '10px', flex: 1, flexWrap: 'wrap' }}
                    >
                      <input
                        type='number'
                        placeholder='Limit (default: 20)'
                        value={analyticsParams.limit}
                        onChange={(e) =>
                          setAnalyticsParams({
                            ...analyticsParams,
                            limit: Number(e.target.value),
                          })
                        }
                        style={{ maxWidth: '150px' }}
                      />
                      <input
                        type='date'
                        placeholder='From Date'
                        value={analyticsParams.from}
                        onChange={(e) =>
                          setAnalyticsParams({
                            ...analyticsParams,
                            from: e.target.value,
                          })
                        }
                      />
                      <input
                        type='date'
                        placeholder='To Date'
                        value={analyticsParams.to}
                        onChange={(e) =>
                          setAnalyticsParams({
                            ...analyticsParams,
                            to: e.target.value,
                          })
                        }
                      />
                      <button onClick={fetchAnalytics}>Fetch Analytics</button>
                    </div>
                    <div className='buttons flex dif'>
                      <button onClick={handleAnalyticsExport}>
                        Export Analytics
                      </button>
                    </div>
                  </div>

                  {analyticsData.topBusinesses &&
                  analyticsData.topBusinesses.length > 0 ? (
                    <>
                      <div className='mobile-table'>
                        {analyticsData.topBusinesses.map(
                          (data: any, i: number) => (
                            <div className='card' key={data.userId}>
                              <div className='flex justify-between row'>
                                <div className='count flex items-center justify-center'>
                                  {i + 1}
                                </div>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Org Name</h4>
                                <p>{data.org_name}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Email</h4>
                                <p>{data.email}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Phone</h4>
                                <p>{data.phonenumber}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Bookings</h4>
                                <p>{data.bookingCount}</p>
                              </div>
                              <div className='row flex justify-between'>
                                <h4>Total Charge</h4>
                                <p>
                                  ₦
                                  {data.totalCharge.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </p>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                      <table className='desktop-table'>
                        <thead>
                          <tr>
                            <th>Rank</th>
                            <th>Org Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Booking Count</th>
                            <th>Total Charge (₦)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {analyticsData.topBusinesses.map(
                            (data: any, i: number) => (
                              <tr key={data.userId}>
                                <td>{i + 1}</td>
                                <td>{data.org_name}</td>
                                <td className='count'>{data.email}</td>
                                <td className='count'>{data.phonenumber}</td>
                                <td className='count'>{data.bookingCount}</td>
                                <td className='count'>
                                  ₦
                                  {data.totalCharge.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <div className='empty flex justify-center'>
                      <div className='empty-cover'>
                        <Icon icon='majesticons:chart-line' />
                        <h1>No Analytics Data To Show</h1>
                        <p>
                          Select date range and fetch analytics to view top
                          businesses
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Businesses
